import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import './assets/css/global.css'

// 禁用 webpack-dev-server 的错误覆盖层（运行时处理）
if (process.env.NODE_ENV === 'development') {
  window.addEventListener('error', (event) => {
    // 忽略 "cancel" 相关的错误
    if (event.message && event.message.includes('cancel')) {
      event.preventDefault()
      event.stopPropagation()
      return false
    }
  }, true)
  
  // 捕获未处理的 Promise 拒绝
  window.addEventListener('unhandledrejection', (event) => {
    if (event.reason && (event.reason.message === 'cancel' || event.reason === 'cancel')) {
      event.preventDefault()
      return false
    }
  })
}

const app = createApp(App)

// 注册所有图标
for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
  app.component(key, component)
}

app.use(store)
app.use(router)
app.use(ElementPlus)
app.mount('#app')
